module.exports = __webpack_public_path__ + "img/Lessonpreparation_active.cf138fc4.png";